"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudySubjectSmsHistory = exports.StudySubjectSmsPayload = exports.StudySubjectDownloadableDataset = exports.StudySubjectContact = exports.StudySubjectSummary = exports.StudySubject = exports.StudySubjectInvokeTriggerHistoryStatus = exports.StudySubjectMigrateStatus = exports.StudySubjectBlindStatus = exports.StudySubjectType = exports.StudySubjectEssential = exports.StudySubjectSigningStatus = exports.StudySubjectStatus = void 0;
// Note: 수정할 때 lib/rest 쪽 StudySubjectStatus 도 함께 수정해야함.
var StudySubjectStatus;
(function (StudySubjectStatus) {
    StudySubjectStatus["NotAvailable"] = "NOT-AVAILABLE";
    StudySubjectStatus["Registering"] = "REGISTERING";
    StudySubjectStatus["Registration"] = "REGISTRATION";
    StudySubjectStatus["Enrolled"] = "ENROLLED";
    StudySubjectStatus["Screening"] = "SCREENING";
    StudySubjectStatus["ScreeningFailed"] = "SCREENING-FAILED";
    StudySubjectStatus["Ongoing"] = "ONGOING";
    StudySubjectStatus["DroppedOut"] = "DROPPED-OUT";
    StudySubjectStatus["Completed"] = "COMPLETED";
})(StudySubjectStatus = exports.StudySubjectStatus || (exports.StudySubjectStatus = {}));
// Note: 수정할 때 lib/rest 쪽 StudySubjectSigningStatus 도 함께 수정해야함.
var StudySubjectSigningStatus;
(function (StudySubjectSigningStatus) {
    StudySubjectSigningStatus["Incomplete"] = "INCOMPLETE";
    StudySubjectSigningStatus["PartiallyCompleted"] = "PARTIALLY_COMPLETED";
    StudySubjectSigningStatus["Completed"] = "COMPLETED";
})(StudySubjectSigningStatus = exports.StudySubjectSigningStatus || (exports.StudySubjectSigningStatus = {}));
// Note: 수정할 때 lib/rest 쪽 StudySubjectEssential 도 함께 수정해야함.
class StudySubjectEssential {
}
exports.StudySubjectEssential = StudySubjectEssential;
var StudySubjectType;
(function (StudySubjectType) {
    StudySubjectType["Subject"] = "SUBJECT";
    StudySubjectType["PreSubject"] = "PRE-SUBJECT";
})(StudySubjectType = exports.StudySubjectType || (exports.StudySubjectType = {}));
var StudySubjectBlindStatus;
(function (StudySubjectBlindStatus) {
    StudySubjectBlindStatus["Blinded"] = "BLINDED";
    StudySubjectBlindStatus["Unblinded"] = "UNBLINDED";
    StudySubjectBlindStatus["UnblindRequested"] = "UNBLIND_REQUESTED";
})(StudySubjectBlindStatus = exports.StudySubjectBlindStatus || (exports.StudySubjectBlindStatus = {}));
var StudySubjectMigrateStatus;
(function (StudySubjectMigrateStatus) {
    StudySubjectMigrateStatus["Wait"] = "WAIT";
    StudySubjectMigrateStatus["Processing"] = "PROCESSING";
    StudySubjectMigrateStatus["Processed"] = "PROCESSED";
    StudySubjectMigrateStatus["Failed"] = "FAILED";
})(StudySubjectMigrateStatus = exports.StudySubjectMigrateStatus || (exports.StudySubjectMigrateStatus = {}));
var StudySubjectInvokeTriggerHistoryStatus;
(function (StudySubjectInvokeTriggerHistoryStatus) {
    StudySubjectInvokeTriggerHistoryStatus["Wait"] = "WAIT";
    StudySubjectInvokeTriggerHistoryStatus["Processing"] = "PROCESSING";
    StudySubjectInvokeTriggerHistoryStatus["Processed"] = "PROCESSED";
    StudySubjectInvokeTriggerHistoryStatus["Failed"] = "FAILED";
})(StudySubjectInvokeTriggerHistoryStatus = exports.StudySubjectInvokeTriggerHistoryStatus || (exports.StudySubjectInvokeTriggerHistoryStatus = {}));
class StudySubject {
}
exports.StudySubject = StudySubject;
class StudySubjectSummary {
}
exports.StudySubjectSummary = StudySubjectSummary;
class StudySubjectContact {
}
exports.StudySubjectContact = StudySubjectContact;
class StudySubjectDownloadableDataset {
}
exports.StudySubjectDownloadableDataset = StudySubjectDownloadableDataset;
class StudySubjectSmsPayload {
}
exports.StudySubjectSmsPayload = StudySubjectSmsPayload;
class StudySubjectSmsHistory {
}
exports.StudySubjectSmsHistory = StudySubjectSmsHistory;
//# sourceMappingURL=studySubject.js.map